// Timing data stays synchronous in the page's ref, independent of React renders.
export const emptyTapSequence = () => ({ lastTap: null, intervals: [] });

export function measureTap(sequence, now) {
  const interval = now - sequence.lastTap;
  if (sequence.lastTap === null || interval > 2000) {
    return { sequence: { lastTap: now, intervals: [] }, status: "Tap again" };
  }
  // Ignore accidental double taps without advancing the last accepted timestamp.
  if (interval < 150) return { sequence };
  const intervals = [...sequence.intervals, interval].slice(-4);
  const bpm = Math.round(60000 / (intervals.reduce((sum, value) => sum + value, 0) / intervals.length));
  return {
    sequence: { lastTap: now, intervals },
    bpm,
    status: `Tempo set to ${bpm} BPM`,
  };
}
